export const enableChatbotReportsBoolean : boolean = false;
export const REPORTS_CHATBOT_HEADER_TEXT : string = "Brisque Insights";
export const REPORTS_CHATBOT_CENTER_TEXT : string = "Ask about sales, employees, refunds and trends.";
export const REPORTS_CHATBOT_FOOTER_TEXT : string = "AI may make mistakes, check any important information given";
export const REPORTS_CHATBOT_MESSAGE_INPUT_PLACEHOLDER : string = "Ask me anything...";
export const REPORTS_CHATBOT_SUGGESTION_PILLS_HEADING : string = "SUGGESTED FOR SALES";
export const REPORTS_CHATBOT_SUGGESTION_PILLS : string[] = [
    "How are my sales today?", 
    "Sales by hour?", 
    "Sales Trends"
];
export const REPORTS_CHATBOT_API_FAILURE_RESPONSE : string = "Unable to retrieve at the moment";
export const REPORTS_CHATBOT_NAME : string = "Brisque bot";